// src/data/api/helios-service/locationService.ts

import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  ListLocationsRequest,
  ListLocationsResponse,
  CreateLocationRequest,
  CreateLocationResponse,
  UpdateLocationRequest,
  UpdateLocationResponse,
  GetLocationRequest,
  GetLocationResponse,
} from 'src/types/helios/Location';

export const locationService = {
  // Get all locations
  getAll: (data: ListLocationsRequest) => {
    return apiClient.get<ListLocationsResponse>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.LOCATIONS.LIST(data.businessUnitId)),
      data,
    );
  },

  // Create location
  createLocation: (data: CreateLocationRequest) => {
    return apiClient.post<CreateLocationResponse, CreateLocationRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.LOCATIONS.CREATE(data.businessUnitId)),
      data,
    );
  },

  // Update location
  updateLocation: (data: UpdateLocationRequest) => {
    return apiClient.put<UpdateLocationResponse, UpdateLocationRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.LOCATIONS.UPDATE(
          data.businessUnitId,
          data.locationCode,
        ),
      ),
      data,
    );
  },
  // Get location
  getLocation: (data: GetLocationRequest) => {
    return apiClient.get<GetLocationResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.LOCATIONS.GET(
          data.businessUnitId,
          data.locationCode,
        ),
      ),
      data,
    );
  },
};
